export default __webpack_public_path__ + "static/media/product-set-1.f6f9f009.png";